import { render, staticRenderFns } from "./PageContainer.vue?vue&type=template&id=4b5dd2ab&scoped=true"
import script from "./PageContainer.vue?vue&type=script&lang=js"
export * from "./PageContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5dd2ab",
  null
  
)

export default component.exports